<div class="container d-flex justify-content-center">
    <div class="banner-overlap">

        <div class="d-flex justify-content-between align-items-center mb-26">
            <h2 class="section-heading">Explore Tenders By Keywords</h2>
            <div class="ml-auto d-flex align-items-center">
                <button class="view-all-outline-btn border-0 ms-3" title="All High Value Tenders List"
                    (click)="navigateToAllTenders($event)">
                    View All
                </button>
            </div>
        </div>

        <div class="phone-width">
            <app-slick-slider [tenders]="highValueTenders" [dataType]="'Keywords'"
                [type]="'Keywords'"></app-slick-slider>



            <div *ngIf="!isMobile">
                <ng-container *ngIf="tendersData; else mobileSkeletonLoader">
                    <div class="d-block d-lg-none">
                        <div class="row mobile-card-row">
                            <div class="col-6" *ngFor="let item of tendersData | slice:0:4 ; let index=index">
                                <div class="card card-9 card-custom-1 text-start mb-4 card-1-min-height mx-0">
                                    <a class="card-header border-0 d-flex justify-content-between align-items-start pb-0"
                                        [href]="baseUrl + '/' + item.link + '-tenders/active'">

                                        <img [src]="item['link'] ? imageBasePath + item['link'] + '.webp' : imageBasePath + 'banner/default.webp'"
                                            [alt]="item?.name" (error)="handleImageError($event)" class="category-img">
                                    </a>
                                    <div class="card-body py-0">
                                        <div class="list-group-horizontal">
                                            <a class="cursor mb-"
                                                [href]="baseUrl + '/' + item.link + '-tenders/active'">
                                                <h3 class="mb-0 heading-min-height">{{item?.name}} Tenders</h3>
                                            </a>
                                            <div class="d-flex justify-content-between align-items-center card-content">
                                                <p class="mb-0">{{item?.count}} Tenders</p>
                                                <a type="button" [href]="baseUrl + '/' + item.link + '-tenders/active'"
                                                    class="btn btn-outline-danger card-view-more">View
                                                    More <i class="arrow-right-red sprite-img d-block d-lg-none"></i>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>

            <ng-template #mobileSkeletonLoader>
                <div class="row" style="padding: 0 15px; justify-content: space-between;">
                    <div class="col-6" style="margin-bottom: 10px; max-width: calc(50% - 5px ); padding: 0 !important;"
                        *ngFor="let _ of [1,2,3,4]">
                        <skeleton-loader [cardWidthContainer]="'skeletoncard-w-sm'"
                            [imageHeightconatiner]="'imageHeight'"></skeleton-loader>
                    </div>
                </div>
            </ng-template>


        </div>
    </div>
</div>